import React from 'react';

const Approach = () => {
  const steps = [
    {
      number: '1',
      title: 'Assess',
      description: 'Comprehensive technology audit and maturity assessment',
      gradient: 'bg-gradient-to-r from-logo-darkblue to-logo-lightblue',
      textColor: 'text-white',
    },
    {
      number: '2',
      title: 'Plan',
      description: 'Strategic roadmap development aligned with business goals',
      gradient: 'bg-gradient-to-r from-logo-green2 to-logo-green3',
      textColor: 'text-white',
    },
    {
      number: '3',
      title: 'Implement',
      description: 'Phased execution with continuous monitoring and adjustment',
      gradient: 'bg-gradient-to-r from-logo-yellow to-logo-green',
      textColor: 'text-logo-navy',
    },
    {
      number: '4',
      title: 'Optimize',
      description: 'Ongoing management, optimization, and innovation',
      gradient: 'bg-gradient-to-r from-logo-teal to-logo-green3',
      textColor: 'text-white',
    },
  ];

  return (
    <section id="approach" className="py-16 sm:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-logo-navy mb-4">
            Our Unique Approach
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto text-base sm:text-lg">
            We embed ourselves within your leadership team to ensure accountability, transparency, 
            and alignment between business goals and technology execution.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className={`w-16 h-16 sm:w-20 sm:h-20 ${step.gradient} rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6`}>
                <span className={`${step.textColor} text-xl sm:text-2xl font-bold`}>
                  {step.number}
                </span>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-logo-navy mb-2">
                {step.title}
              </h3>
              <p className="text-gray-600 text-sm sm:text-base">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Approach;